export const DeploymentOptions = {
  PROFESSIONAL: 'Professional',
  BUSINESS: 'Business',
  VIRTUAL_PRIVATE_TESSELL: 'VPT',
  VIRTUAL_PRIVATE_TESSELL_AT_CUSTOMER: 'VPT @ Customer',
};
